export default __webpack_public_path__ + "static/media/CoventGardenChristmas.7bb9dcd4.jpeg";